'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBrowserLocale = undefined;

var _prop = require('lodash/fp/prop');

var _prop2 = _interopRequireDefault(_prop);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _windowIO = require('../IO/windowIO');

var _windowIO2 = _interopRequireDefault(_windowIO);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMMON_LANGS = ['en_US', 'fr_FR', 'de_DE', 'it_IT', 'es_ES'];


function autofillLanguage(language) {
  var locales = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return (0, _find2.default)(locales.concat(COMMON_LANGS), function (lang) {
    return new RegExp('^' + language).test(lang);
  }) || null;
}

/**
 * Get the browser's language.
 * @param {Array} [locales] - customized common language look up list
 * @return - locale identifier like en_US, fr_FR etc.
 *
 * @example
 *
 *    // browser locale -> zh_CN
 *    getBrowserLocale() // 'zh_CN'
 *
 *    // browser locale -> en
 *    getBrowserLocale() // 'en_US'
 *
 *    // browser locale -> en
 *    getBrowserLocale([ 'fr_FR', 'en_GB' ]) // 'en_GB'
  * */
var getBrowserLocale = exports.getBrowserLocale = function getBrowserLocale(locales) {
  var _windowIO$map$unsafeP = _windowIO2.default.map((0, _prop2.default)('navigator')).unsafePerformIO(),
      language = _windowIO$map$unsafeP.language,
      userLanguage = _windowIO$map$unsafeP.userLanguage,
      systemLanguage = _windowIO$map$unsafeP.systemLanguage,
      browserLanguage = _windowIO$map$unsafeP.browserLanguage;

  var localLanguage = language || userLanguage || systemLanguage || browserLanguage;
  var languageWords = localLanguage.split('-');
  return languageWords.length > 1 ? languageWords[0] + '_' + languageWords[1].toUpperCase() : autofillLanguage(languageWords[0], locales);
};